import {
  GET_MASTER_CATEGORY,
  GET_MASTER_ACTIVITY,
  SET_ONBOARD_SLIDE_2_DATA,
  SET_ONBOARD_SLIDE_3_DATA,
  GET_TIMEZONE_FOR_ONBOARDING_SCREEN,
  GET_ASSET_TYPE_FOR_ONBOARDING_SCREEN,
  RESET_REDUX_STATE
} from "../constants";

const initialValue = {
  masterActivity: [],
  masterCategory: [],
  slider_2_Data: {},
  slider_3_Data: {},
  time_zone_for_onboarding : [],
  asset_type_for_onboarding : []
};

const onboarding = (state = initialValue, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MASTER_CATEGORY: {
      return {
        ...state,
        masterCategory: payload,
      };
    }

    case GET_MASTER_ACTIVITY: {
      return {
        ...state,
        masterActivity: payload,
      };
    }

    case SET_ONBOARD_SLIDE_2_DATA: {
      return {
        ...state,
        slider_2_Data: payload,
      };
    }

    case SET_ONBOARD_SLIDE_3_DATA: {
      return {
        ...state,
        slider_3_Data: payload,
      };
    }

    case GET_TIMEZONE_FOR_ONBOARDING_SCREEN : {
      return {
        ...state,
        time_zone_for_onboarding: payload
      }
    }

    case GET_ASSET_TYPE_FOR_ONBOARDING_SCREEN : {
      return {
        ...state,
        asset_type_for_onboarding: payload
      }
    }

    case RESET_REDUX_STATE: {
      return initialValue
    }

    default:
      return state;
  }
};

export default onboarding;
